import React, {useState} from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Button, Divider, Layout, Text } from '@ui-kitten/components';
import { StyleSheet, ScrollView, View } from 'react-native';
import {AgentInfo} from './agentInfo.js'
import {CustomerInfo} from './customerInfo.js'
import {ServiceInfo} from './serviceInfo.js'
import {TopBar} from './topBar.js'
import {SaveButton } from './save.js'

export const AddressScreen =  () => {

  return (
      <Layout style={styles.container} level='2' >
        <TopBar />
        <ScrollView>
          <View style={{paddingHorizontal:8}} >
            <Text status='primary' style={{marginHorizontal:8, marginTop:15}}>مشخصات تکنسین</Text>
            <AgentInfo />
            <Text status='primary' style={{marginHorizontal:8, marginTop:15}}>مشخصات مشتری</Text>
            <CustomerInfo />
            <Text status='primary' style={{marginHorizontal:8, marginTop:15}}>مشخصات دستگاه</Text>
            <ServiceInfo />
            <SaveButton />
          </View>
        </ScrollView>
      </Layout>
  );
};

const styles = StyleSheet.create({
  container:{
    flex:1,
  },
});
